import StatusSegmentBar from './StatusSegmentBar';
import StatusLegend from './StatusLegend';
import { VisitStatus } from '../enums';

export interface StatusSegment {
  name: string;
  status: VisitStatus;
  value: number;
  color: string;
}

interface DeliveryStatusBarProps {
  deliveredCount: number;
  failedCount: number;
  pendingCount: number;
  expiredCount?: number;
  onSegmentClick?: (status: VisitStatus | null) => void;
  selectedStatus?: VisitStatus | null;
}

const COLORS = {
  delivered: '#10B981',
  failed: '#EF4444',
  pending: '#3B82F6',
  expired: '#6B7280',
};

const DeliveryStatusBar = ({
  deliveredCount,
  failedCount,
  pendingCount,
  expiredCount = 0,
  onSegmentClick,
  selectedStatus,
}: DeliveryStatusBarProps) => {
  const delivered = Math.max(0, Math.floor(Number(deliveredCount) || 0));
  const failed = Math.max(0, Math.floor(Number(failedCount) || 0));
  const pending = Math.max(0, Math.floor(Number(pendingCount) || 0));
  const expired = Math.max(0, Math.floor(Number(expiredCount) || 0));

  const total = delivered + failed + pending + expired;
  const hasData = total > 0;

  const segments: StatusSegment[] = [
    {
      name: 'Visitas completadas',
      status: VisitStatus.COMPLETED,
      value: delivered,
      color: COLORS.delivered,
    },
    {
      name: 'Visitas fallidas',
      status: VisitStatus.FAILED,
      value: failed,
      color: COLORS.failed,
    },
    {
      name: 'Visitas pendientes',
      status: VisitStatus.PENDING,
      value: pending,
      color: COLORS.pending,
    },
    {
      name: 'Visitas expiradas',
      status: VisitStatus.EXPIRED,
      value: expired,
      color: COLORS.expired,
    },
  ];

  const handleToggle = (status: VisitStatus) => {
    if (!onSegmentClick) return;
    onSegmentClick(selectedStatus === status ? null : status);
  };

  return (
    <div className='flex h-full min-h-0 flex-col rounded-lg bg-white p-6 shadow-md'>
      <div className='mb-4 flex items-center justify-between shrink-0'>
        <h3 className='text-lg font-bold text-gray-800'>Estado de visitas</h3>
        {selectedStatus && (
          <button
            onClick={() => onSegmentClick?.(null)}
            className='text-base font-bold text-[var(--primary-color)] hover:underline bg-orange-100 px-4 py-2 rounded-full transition-all hover:bg-orange-200 cursor-pointer shadow-sm'
          >
            Ver todas
          </button>
        )}
      </div>

      {hasData ? (
        <div className='flex flex-col gap-5'>
          <StatusSegmentBar
            segments={segments}
            total={total}
            selectedStatus={selectedStatus}
            onToggle={handleToggle}
          />
          <StatusLegend
            segments={segments}
            selectedStatus={selectedStatus}
            onToggle={handleToggle}
          />
        </div>
      ) : (
        <div className='flex min-h-[120px] flex-1 items-center justify-center text-sm text-gray-500'>
          Sin visitas en esta ruta
        </div>
      )}
    </div>
  );
};

export default DeliveryStatusBar;
